var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleGreenRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 97,
    fill: "none",
    viewBox: "0 0 1440 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCD0E1",
    d: "M-.193.437H1439.81L-.193 96.464V.437z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E8DD",
    d: "M-.193 96.464L1439.81.437v96.027H-.193z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleGreenRectangle);
export default __webpack_public_path__ + "static/media/PurpleGreenRectangle.d2a474fa1ab72293004559a7c3bf8aec.svg";
export { ForwardRef as ReactComponent };